import { useQuery } from "@tanstack/react-query";
import { getProtectionZoneSummary } from "../../api/captures/protectionZone";

export const useProtectionZoneSummary = (managementUnitIdStr?: string) => {
  const managementUnitId = Number(managementUnitIdStr);

  const result = useQuery({
    queryKey: ["managementUnit", managementUnitId, "protectionZoneSummary"],
    queryFn: () => getProtectionZoneSummary(undefined, managementUnitId),
    enabled: !!managementUnitId,
  });

  return {
    protectionZoneSummaryData: result.data,
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    refetch: result.refetch,
  };
};
